/**
 * What a query looks like from a component that holds the page while it
 * loads. Structural, so a test can hand in a plain object.
 */
export type QueryLoadState = {
  isLoading: boolean;
  errorUpdateCount: number;
};

/**
 * Loading, and never failed. This is the only state worth holding a page
 * for: a query that failed once is refetched whenever a component mounts,
 * and react-query reports that refetch as loading again. A page that
 * unmounts its children on it fails again, mounts them again, and loops for
 * as long as the tab is open.
 */
export const isFirstLoad = (query: QueryLoadState): boolean =>
  query.isLoading && query.errorUpdateCount === 0;
